// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XTYB","colBig":"styles_colBig__d3-gx","colSmall":"styles_colSmall__1s6vX","shopifyNameWrapper":"styles_shopifyNameWrapper__39w3f"};